import React, { useState, useEffect, lazy, Suspense, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// Removed LayoutProvider import
import AffiliateDashboard from '../../components/AffiliateDashboard';
import RaffleTabWrapper from '../../components/RaffleTabWrapper';
import NewRaffleTab from '../../components/NewRaffleTab';
import DashboardValueBoxes from '../../components/Charts/DashboardValueBoxes';
import { 
  Box, 
  useToast, 
  useColorModeValue, 
  VStack, 
  Icon, 
  Text, 
  Heading, 
  SimpleGrid, 
  Flex, 
  Button, 
  Image, 
  Badge, 
  HStack, 
  Divider, 
  Tabs, 
  TabList, 
  Tab, 
  TabPanels, 
  TabPanel,
  Center,
  Spinner,
  Progress,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Select,
  Grid,
  GridItem,
  Avatar,
  AvatarBadge,
  IconButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from '@chakra-ui/react';
import DEXSwapComponent from '../DEXSwap/DEXSwap';
import DAODashboard from '../DAODashboard/DAODashboard';
import { Link as RouterLink } from 'react-router-dom';
import { useWallet } from '@solana/wallet-adapter-react';
import { useBalance } from '../../context/BalanceContext';
import { useGame } from '../../game/context/GameContext';
import { fetchSolPrice, getTimeUntilFridayLottery } from '../../utils/priceUtils';
import { 
  FaChartLine, 
  FaGamepad, 
  FaGift, 
  FaStore, 
  FaExchangeAlt, 
  FaHandHoldingUsd, 
  FaTicketAlt, 
  FaCoins, 
  FaChartBar, 
  FaWallet, 
  FaUsers, 
  FaUserAlt, 
  FaCalendarAlt, 
  FaClock, 
  FaChartPie, 
  FaRegChartBar, 
  FaRegClock, 
  FaArrowUp, 
  FaArrowDown, 
  FaPlus, 
  FaMinus, 
  FaSearch, 
  FaFilter, 
  FaSort, 
  FaLink, 
  FaTwitter, 
  FaDiscord, 
  FaTelegram, 
  FaMoneyBillWave, 
  FaInfoCircle, 
  FaTrophy, 
  FaFire, 
  FaDharmachakra, 
  FaDice,
  FaCog,
  FaCamera,
  FaEdit,
  FaSave,
  FaUpload,
  FaShareAlt,
  FaSignOutAlt
} from 'react-icons/fa';
import { GiPirateFlag, GiTreasureMap, GiChest, GiCutlass, GiPirateHat, GiCoins } from 'react-icons/gi';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import '../../components/WalletButtonStyles.css';
import NavbarFix from '../../components/NavbarFix';
import ProfileSidebar from '../../components/ProfileSidebar';
import CommunityChatSidebar from '../../components/CommunityChatSidebar';
import UserStatsBoxes from '../../components/UserStatsBoxes';
import GamesContent from '../../components/GamesContent';
import ModularGamesContent from '../../components/ModularGamesContent';
import MarketPerformanceSection from '../../components/MarketPerformanceSection';
import CommunityActivityHub from '../../components/CommunityActivityHub';
import GamePanel from '../../game/components/GameUI/GamePanel';
import VRFInfo from '../../game/components/GameUI/VRFInfo';

import GameControls from '../../game/components/GameUI/GameControls';
import GameInfo from '../../game/components/GameUI/GameInfo';
import DashboardAdapter from '../../game/adapters/DashboardAdapter';
import { useDashboard } from '../../game/hooks/useDashboard';
import { useGameStore } from '../../game/stores/gameStore';

// Lazy load components
const PawnShopComponent = lazy(() => import('../PawnShop/PawnShop'));
const NFTLootboxesComponent = lazy(() => import('../NFTLootboxes/NFTLootboxes'));
// DEXSwapComponent and DAODashboard are already imported at the top of the file


// Lazy load game components
const CardGrid = lazy(() => import('../../game/components/GameUI/CardGrid'));
const FortuneWheel = lazy(() => import('../../game/components/GameUI/FortuneWheel'));
const GiftBoxGame = lazy(() => import('../../game/components/GameUI/GiftBoxGame'));
const LootboxGame = lazy(() => import('../../game/components/GameUI/LootboxGame'));
const NFTMarketplace = lazy(() => import('../../game/components/GameUI/NFTMarketplace'));

const ChestBonus = lazy(() => import('../../game/components/GameUI/ChestBonus'));
const SingleFlippingCard = lazy(() => import('../../game/components/GameUI/SingleFlippingCard'));
const PoolInfo = lazy(() => import('../../game/components/GameUI/PoolInfo'));
const RTPInfo = lazy(() => import('../../game/components/GameUI/RTPInfo'));

// Utility function to format time remaining for raffles
const formatTimeRemaining = (endDate) => {
  const end = new Date(endDate);
  const now = new Date();
  const diff = end - now;
  
  if (diff <= 0) return 'Ended';
  
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  
  return `${days}d ${hours}h remaining`;
};

const ModularUserProfile = ({ initialSection, initialGame }) => {
  // Color theme values
  const goldColor = useColorModeValue('yellow.400', 'yellow.400');
  const goldBorder = useColorModeValue('yellow.500', 'yellow.500');
  const goldAccent = useColorModeValue('yellow.300', 'yellow.300');
  const goldShadow = useColorModeValue('0 0 15px rgba(255, 215, 0, 0.3)', '0 0 15px rgba(255, 215, 0, 0.3)');
  
  // Navigation and location hooks for URL handling and redirection
  const navigate = useNavigate();
  const location = useLocation();
  
  // State management
  const [activeSection, setActiveSection] = useState(initialSection || "dashboard");
  const [activeGame, setActiveGame] = useState(initialGame || null);
  
  // Debug logging for activeSection and activeGame
  useEffect(() => {
    console.log('ModularUserProfile - activeSection:', activeSection);
    console.log('ModularUserProfile - activeGame:', activeGame);
    console.log('ModularUserProfile - initialSection:', initialSection);
    console.log('ModularUserProfile - initialGame:', initialGame);
  }, [activeSection, activeGame, initialSection, initialGame]);
  
  // Profile settings state
  const [profileData, setProfileData] = useState({
    username: "Pirate Captain",
    avatar: "https://avatars.dicebear.com/api/human/123.svg",
    bio: "Crypto enthusiast and NFT collector",
    twitter: "@palmheistuser",
    discord: "palmheistuser#1234"
  });
  
  // Profile picture editing state
  const [tempAvatar, setTempAvatar] = useState(null);
  const [isEditingAvatar, setIsEditingAvatar] = useState(false);
  const [avatarPreview, setAvatarPreview] = useState(null);
  
  // File input reference for avatar upload
  const fileInputRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  // Avatar modal controls
  const { 
    isOpen: isAvatarModalOpen, 
    onOpen: onAvatarModalOpen, 
    onClose: onAvatarModalClose 
  } = useDisclosure();
  
  // State for tracking active game in games section is now initialized with initialGame prop

  // Parse URL parameters to set the active tab and game
  useEffect(() => {
    console.log('ModularUserProfile - URL path:', location.pathname);
    
    // Check if we're using the new RESTful URL structure
    const pathParts = location.pathname.split('/');
    
    // Handle path-based routing (new RESTful structure)
    if (pathParts.length >= 3 && pathParts[1] === 'modular-profile') {
      const section = pathParts[2];
      console.log('ModularUserProfile - Section from path:', section);
      
      // Set active section based on the URL path
      switch(section) {
        case 'games':
          setActiveSection('games');
          
          // If we have a game type specified
          if (pathParts.length >= 4) {
            if (pathParts[3] === 'scratch-cards') {
              setActiveGame('scratchCard');
              
              // If we have a specific card type
              if (pathParts.length >= 5) {
                // Check if this is a custom game page route
                if (pathParts[4] === 'game' && pathParts.length >= 6) {
                  // This is a custom game page route (e.g., /modular-profile/games/scratch-cards/game/game_123)
                  console.log('ModularUserProfile - Custom game page route detected with game ID:', pathParts[5]);
                  setActiveGame('customGamePage');
                } else {
                  // Regular card type route
                  console.log('ModularUserProfile - Card type:', pathParts[4]);
                }
              }
            } else if (pathParts[3] === 'island-map') {
              // Handle island-map path explicitly - don't set any specific game
              setActiveGame(null);
            } else {
              // Handle other game types
              setActiveGame(pathParts[3]);
            }
          }
          break;
        case 'dashboard':
        case 'nftlootboxes':
        case 'raffles':
        case 'pawnshop':
        case 'marketplace':
        case 'dex':
        case 'staking':
        case 'dao':
        case 'affiliate':
          setActiveSection(section);
          break;
        default:
          // Default to dashboard if section is not recognized
          setActiveSection('dashboard');
      }
      return;
    }
    
    // If initialSection and initialGame are provided (from props), use those
    if (initialSection || initialGame) {
      console.log('ModularUserProfile - Using props:', initialSection, initialGame);
      return;
    }
    
    // Otherwise, fall back to query parameters for backward compatibility
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    const sectionParam = params.get('section');
    const gameParam = params.get('game');
    console.log('ModularUserProfile - Using query params:', sectionParam, gameParam);
    
    // Set active section based on parameters
    if (sectionParam) {
      switch(sectionParam.toLowerCase()) {
        case 'dashboard':
          setActiveSection('dashboard');
          break;
        case 'games':
        case 'nftlootboxes':
        case 'raffles':
        case 'pawnshop':
        case 'marketplace':
        case 'dex':
        case 'staking':
        case 'dao':
        case 'affiliate':
          setActiveSection(sectionParam.toLowerCase());
          break;
        default:
          // Default to overview if parameter is not recognized
          setActiveSection('overview');
      }
    } else if (tabParam) {
      // For backward compatibility
      switch(tabParam.toLowerCase()) {
        case 'dashboard':
          setActiveSection('dashboard');
          break;
        case 'games':
        case 'nftlootboxes':
        case 'raffles':
        case 'pawnshop':
        case 'marketplace':
        case 'dex':
        case 'staking':
        case 'dao':
        case 'affiliate':
          setActiveSection(tabParam.toLowerCase());
          break;
        default:
          // Default to overview if parameter is not recognized
          setActiveSection('overview');
      }
    }
    
    // Set active game if games section is active
    if ((sectionParam === 'games' || tabParam === 'games') && gameParam) {
      setActiveGame(gameParam.toLowerCase());
    }
  }, [location, navigate, initialSection, initialGame]);
  const cardBg = useColorModeValue('gray.800', 'gray.800');
  
  // Raffle state variables
  const [raffleAssetType, setRaffleAssetType] = useState('nft');
  const [selectedRaffleNft, setSelectedRaffleNft] = useState('');
  const [selectedTokenSymbol, setSelectedTokenSymbol] = useState('JINU');
  const [selectedTokenAmount, setSelectedTokenAmount] = useState(1000);
  const [selectedTokenAddress, setSelectedTokenAddress] = useState('');
  const [raffleTicketPrice, setRaffleTicketPrice] = useState(100);
  const [raffleTotalTickets, setRaffleTotalTickets] = useState(50);
  const [raffleDuration, setRaffleDuration] = useState(7);
  const [topTokens, setTopTokens] = useState([
    { symbol: 'JINU', name: 'JINU Token', image: '/images/token-placeholder.png', price: 1 },
    { symbol: 'SOL', name: 'Solana', image: '/images/solana-logo.png', price: 172.45 },
    { symbol: 'BONK', name: 'Bonk', image: '/images/bonk-logo.png', price: 0.00002 },
    { symbol: 'JUP', name: 'Jupiter', image: '/images/jupiter-logo.png', price: 0.85 }
  ]);
  const [searchTokens, setSearchTokens] = useState([]);
  const [tokenSearchQuery, setTokenSearchQuery] = useState('');
  // Real user NFTs from the NFT folder
  const [userNFTs, setUserNFTs] = useState([]);
  // User raffles with real NFT images
  const [userRaffles, setUserRaffles] = useState([]);
  
  // Function to load NFTs from the NFT folder
  useEffect(() => {
    // NFT file names from the images/NFT folder
    const nftFiles = [
      '777.png',
      'CatKo-nft.png',
      'Monkey-Boss.jpg',
      'Red-Dino.gif',
      'SolNoris.jpg',
      'What-is-y00ts-NFT.jpg',
      'angels-key.gif',
      'bluelio.jpg',
      'eee-nft.png',
      'jinu.gif',
      'lazio.gif',
      'monke.jpg',
      'nft.jpg',
      'rabi-rich.jpg',
      'skull.png',
      'skyso.jpg',
      'solanso.jpg',
      'ss-nft.jpg',
      'uncle-rich.jpg',
      'y00ts-King.png',
      'y00ts-NFT.jpg',
      'y00ts.png'
    ];

    // Generate NFT data from file names
    const nfts = nftFiles.map(file => {
      // Extract name from filename (remove extension and replace dashes/hyphens with spaces)
      const nameWithoutExt = file.split('.')[0];
      const formattedName = nameWithoutExt.replace(/-/g, ' ').replace(/nft/gi, 'NFT');
      
      // Generate a random price between 1000 and 10000
      const price = Math.floor(Math.random() * 9000) + 1000;
      
      return {
        id: nameWithoutExt,
        name: formattedName,
        image: `/images/NFT/${file}`,
        value: price,
        price: price
      };
    });

    setUserNFTs(nfts);
  }, []);
  
  // Initialize user raffles with real NFT images
  useEffect(() => {
    // Only set user raffles if userNFTs are loaded
    if (userNFTs.length > 0) {
      // Use the first two NFTs from the userNFTs array
      const nft1 = userNFTs[0];
      const nft2 = userNFTs[1];
      
      setUserRaffles([
        {
          id: 'raffle1',
          asset: { id: nft1.id, name: nft1.name, image: nft1.image, value: nft1.price },
          ticketPrice: 100,
          totalTickets: 50,
          soldTickets: 25,
          endDate: '2025-04-30',
          status: 'active'
        },
        {
          id: 'raffle2',
          asset: { id: nft2.id, name: nft2.name, image: nft2.image, value: nft2.price },
          ticketPrice: 150,
          totalTickets: 40,
          soldTickets: 40,
          endDate: '2025-04-20',
          status: 'completed',
          winner: 'Pirate0x456...789'
        }
      ]);
    }
  }, [userNFTs]);
  // Active raffles with real NFT images
  const [activeRaffles, setActiveRaffles] = useState([]);
  
  // Initialize active raffles with real NFT images
  useEffect(() => {
    // Only set active raffles if userNFTs are loaded
    if (userNFTs.length > 0) {
      // Use different NFTs for active raffles (starting from index 2)
      const nft3 = userNFTs.length > 2 ? userNFTs[2] : userNFTs[0];
      const nft4 = userNFTs.length > 3 ? userNFTs[3] : userNFTs[1];
      
      setActiveRaffles([
        {
          id: 'raffle3',
          asset: { id: nft3.id, name: nft3.name, image: nft3.image, value: nft3.price },
          ticketPrice: 80,
          totalTickets: 60,
          soldTickets: 45,
          endDate: '2025-05-15',
          creator: 'Pirate0x789...123',
          isToken: false
        },
        {
          id: 'raffle4',
          asset: { id: nft4.id, name: nft4.name, image: nft4.image, value: nft4.price },
          ticketPrice: 120,
          totalTickets: 30,
          soldTickets: 28,
          endDate: '2025-05-05',
          creator: 'Pirate0x456...789',
          isToken: false
        },
        {
          id: 'raffle5',
          asset: { id: 'token1000', name: '1000 JINU Tokens', image: '/images/token-placeholder.png', value: 1000 },
          ticketPrice: 50,
          totalTickets: 30,
          soldTickets: 10,
          endDate: '2025-04-30',
          creator: 'Pirate0x123...789',
          isToken: true
        }
      ]);
    }
  }, [userNFTs]);
  
  const [jinuPrice, setJinuPrice] = useState(0.028);
  const [solPrice, setSolPrice] = useState(75.32);
  // Chart timeframe is now managed by the useDashboard hook
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [lotteryCountdown, setLotteryCountdown] = useState({ days: 0, hours: 0, minutes: 0 });
  
  // Toast for notifications
  const toast = useToast();
  
  // Raffle utility functions
  const handleTokenSearch = async (query) => {
    if (!query) {
      setSearchTokens([]);
      return;
    }
    
    try {
      // In a real implementation, this would call the CoinGecko API
      // For now, we'll simulate a search with our top tokens
      const results = topTokens.filter(token => 
        token.name.toLowerCase().includes(query.toLowerCase()) || 
        token.symbol.toLowerCase().includes(query.toLowerCase())
      );
      
      setSearchTokens(results);
    } catch (error) {
      console.error('Error searching tokens:', error);
      toast({
        title: 'Error',
        description: 'Failed to search tokens. Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    }
  };
  
  const handleCreateRaffle = () => {
    const selectedNft = userNFTs.find(nft => nft.id === selectedRaffleNft);
    const assetName = raffleAssetType === 'nft' 
      ? selectedNft?.name || 'Unknown NFT'
      : `${selectedTokenAmount} ${selectedTokenSymbol}`;
    
    // Create a new raffle with the selected NFT
    if (selectedNft && raffleAssetType === 'nft') {
      const newRaffle = {
        id: `raffle-${Date.now()}`,
        asset: { 
          id: selectedNft.id, 
          name: selectedNft.name, 
          image: selectedNft.image, 
          value: selectedNft.price 
        },
        ticketPrice: raffleTicketPrice,
        totalTickets: raffleTotalTickets,
        soldTickets: 0,
        endDate: new Date(Date.now() + (raffleDuration * 24 * 60 * 60 * 1000)).toISOString().split('T')[0],
        status: 'active'
      };
      setUserRaffles(prevRaffles => [newRaffle, ...prevRaffles]);
    } else if (raffleAssetType === 'token') {
      const newRaffle = {
        id: `raffle-${Date.now()}`,
        asset: { 
          id: `token-${Date.now()}`, 
          name: `${selectedTokenAmount} ${selectedTokenSymbol}`, 
          image: '/images/token-placeholder.png', 
          value: selectedTokenAmount 
        },
        ticketPrice: raffleTicketPrice,
        totalTickets: raffleTotalTickets,
        soldTickets: 0,
        endDate: new Date(Date.now() + (raffleDuration * 24 * 60 * 60 * 1000)).toISOString().split('T')[0],
        status: 'active'
      };
      setUserRaffles(prevRaffles => [newRaffle, ...prevRaffles]);
    }
      
    toast({
      title: 'Raffle Created',
      description: `Your raffle for ${assetName} has been created successfully!`,
      status: 'success',
      duration: 5000,
      isClosable: true
    });
    
    // Reset form
    setSelectedRaffleNft('');
    setSelectedTokenAmount(1000);
    setRaffleTicketPrice(100);
    setRaffleTotalTickets(50);
    setRaffleDuration(7);
    
    // In a real implementation, this would call an API to create the raffle
    // For now, we'll add it to the user's raffles
    const newRaffle = {
      id: `raffle${Date.now()}`,
      asset: raffleAssetType === 'nft'
        ? userNFTs.find(nft => nft.id === selectedRaffleNft) || { name: 'Unknown NFT', image: '/images/nft-placeholder-blue.png' }
        : { id: `token${selectedTokenAmount}`, name: `${selectedTokenAmount} ${selectedTokenSymbol}`, image: '/images/token-placeholder.png', value: selectedTokenAmount },
      ticketPrice: raffleTicketPrice,
      totalTickets: raffleTotalTickets,
      soldTickets: 0,
      endDate: new Date(Date.now() + raffleDuration * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      status: 'active',
      isToken: raffleAssetType === 'token'
    };
    
    setUserRaffles([newRaffle, ...userRaffles]);
    setActiveRaffles([newRaffle, ...activeRaffles]);
    // Reset form
    setSelectedRaffleNft('');
    setSelectedTokenAmount(1000);
    setRaffleTicketPrice(100);
    setRaffleTotalTickets(50);
    setRaffleDuration(7);
  };
  
  const handleBuyTickets = (raffleId, quantity = 1) => {
    toast({
      title: 'Tickets Purchased',
      description: `You've purchased ${quantity} ticket(s) for this raffle.`,
      status: 'success',
      duration: 3000,
      isClosable: true
    });
    
    // Update the active raffles with the new ticket count
    setActiveRaffles(activeRaffles.map(raffle => {
      if (raffle.id === raffleId) {
        return {
          ...raffle,
          soldTickets: raffle.soldTickets + quantity
        };
      }
      return raffle;
    }));
  };
  
  const handleShareRaffle = (raffleId) => {
    // In a real implementation, this would generate a shareable link
    const shareableLink = `https://palm-heist.io/raffle/${raffleId}`;
    
    // Copy to clipboard
    navigator.clipboard.writeText(shareableLink).then(() => {
      toast({
        title: 'Link Copied',
        description: 'Raffle link copied to clipboard!',
        status: 'success',
        duration: 3000,
        isClosable: true
      });
    }).catch(err => {
      console.error('Failed to copy: ', err);
      toast({
        title: 'Error',
        description: 'Failed to copy link. Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    });
  };
  
  // Get balance from BalanceContext
  const { balance, addToBalance, subtractFromBalance } = useBalance();
  
  // User stats (would normally come from API/blockchain)
  const [userStats, setUserStats] = useState({
    username: "Pirate Captain",
    avatar: "https://bit.ly/broken-link",
    solContributed: 2.5,
    totalReferrals: 8,
    totalEarnings: 250,
    daoPower: 185,
    rank: "Fish",
    level: 5,
    xp: 2500,
    nextLevelXp: 5000,
    joinDate: "2025-01-15",
    lastActive: "2025-04-14",
    loans: {
      active: 2,
      totalBorrowed: 15000,
      totalLent: 35000,
      interestEarned: 1250,
      nextDueDate: "2025-04-05"
    },
    profitLoss: {
      "24h": 1250,
      "7d": 8750,
      "31d": -3200
    },
    activeLoans: 2,
    activeRaffles: 1,
    activeAuctions: 3,
    achievements: [
      { id: 1, name: "First Win", description: "Win your first game", completed: true },
      { id: 2, name: "High Roller", description: "Bet 100 JINU in a single game", completed: true },
      { id: 3, name: "Jackpot", description: "Win the progressive jackpot", completed: false },
      { id: 4, name: "Social Butterfly", description: "Refer 10 friends", completed: false },
      { id: 5, name: "Diamond Hands", description: "Hold JINU for 30 days", completed: true }
    ],
    tickets: 450,
    bonusGames: 8,
    ticketsCollected: 450
  });
  
  // Update userStats when balance changes
  useEffect(() => {
    setUserStats(prevStats => ({
      ...prevStats,
      jinuBalance: balance.jinu,
      solBalance: balance.sol
    }));
  }, [balance]);

  // Fetch SOL price from CoinGecko API
  useEffect(() => {
    const getSolPrice = async () => {
      const price = await fetchSolPrice();
      if (price) {
        setSolPrice(price);
      }
    };
    
    // Fetch price immediately
    getSolPrice();
    
    // Set up interval to refresh price every 5 minutes
    const priceInterval = setInterval(getSolPrice, 5 * 60 * 1000);
    
    return () => clearInterval(priceInterval);
  }, []);
  
  // Update lottery countdown
  useEffect(() => {
    // Initial calculation
    setLotteryCountdown(getTimeUntilFridayLottery());
    
    // Update countdown every minute
    const countdownInterval = setInterval(() => {
      setLotteryCountdown(getTimeUntilFridayLottery());
    }, 60 * 1000);
    
    return () => clearInterval(countdownInterval);
  }, []);
  
  // Connect to the game engine using our custom hook
  const {
    userStats: engineUserStats,
    chartTimeframe: engineChartTimeframe,
    setChartTimeframe: setEngineChartTimeframe,
    getTimeframeData,
    recentActivity,
    addActivity,
    updateDashboard
  } = useDashboard({
    balance: balance,
    solContributed: 2.5,
    totalReferrals: 8,
    totalEarnings: 250,
    daoPower: 185
  });
  
  // Connect to the game store directly for additional data
  const dashboard = useGameStore(state => state.dashboard);
  
  // Sync user stats with game engine
  useEffect(() => {
    if (userStats) {
      // Update the game engine dashboard with user stats
      updateDashboard({
        userSolContributed: userStats.solContributed || 2.5,
        totalReferrals: userStats.totalReferrals || 8,
        totalEarnings: userStats.totalEarnings || 250,
        daoPower: userStats.daoPower || 185
      });
    }
  }, [userStats, updateDashboard]);
  
  // Add activity to the game engine when relevant actions occur
  const addGameActivity = (activity) => {
    addActivity(activity);
  };

  // User stats are defined above
  
  // Recent activity data
  const [recentActivityState, setRecentActivityState] = useState([
    {
      id: 1,
      type: "marketplace",
      action: "sold",
      item: "Pirate Hat NFT #123",
      amount: 2500,
      currency: "JINU",
      timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString()
    },
    {
      id: 2,
      type: "raffle",
      action: "won",
      item: "Legendary Sword NFT",
      amount: null,
      currency: null,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString()
    },
    {
      id: 3,
      type: "loan",
      action: "borrowed",
      item: null,
      amount: 5000,
      currency: "JINU",
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12).toISOString()
    },
    {
      id: 4,
      type: "marketplace",
      action: "listed",
      item: "Golden Key #456",
      amount: 7500,
      currency: "JINU",
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString()
    },
    {
      id: 5,
      type: "game",
      action: "won",
      item: "Fortune Wheel",
      amount: 1200,
      currency: "JINU",
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 36).toISOString()
    }
  ]);
  
  // Chart data (would normally come from API/blockchain)
  const [chartData, setChartData] = useState([
    { 
      date: 'Feb 1', 
      jinuPrice: 0.0000, 
      solPrice: 160.00, 
      userProfitLoss: 0.0000, 
      progressiveJackpot: 10000,
      activePlayers: 100,
      activeBorrowers: 0.0000, 
      activeStakers: 200,
      activeLenders: 150
    },
    { 
      date: 'Feb 15', 
      jinuPrice: 0.0005, 
      solPrice: 158.00, 
      userProfitLoss: 0.0005, 
      progressiveJackpot: 15000,
      activePlayers: 250,
      activeBorrowers: 0.0008, 
      activeStakers: 300,
      activeLenders: 220
    },
    { 
      date: 'Mar 1', 
      jinuPrice: 0.0010, 
      solPrice: 155.00, 
      userProfitLoss: 0.0010, 
      progressiveJackpot: 25000,
      activePlayers: 400,
      activeBorrowers: 0.0015, 
      activeStakers: 400,
      activeLenders: 350
    },
    { 
      date: 'Mar 10', 
      jinuPrice: 0.0015, 
      solPrice: 150.00, 
      userProfitLoss: 0.0015, 
      progressiveJackpot: 35000,
      activePlayers: 600,
      activeBorrowers: 0.0020, 
      activeStakers: 500,
      activeLenders: 450
    },
    { 
      date: 'Mar 20', 
      jinuPrice: 0.0020, 
      solPrice: 147.00, 
      userProfitLoss: 0.0018, 
      progressiveJackpot: 40000,
      activePlayers: 800,
      activeBorrowers: 0.0022, 
      activeStakers: 650,
      activeLenders: 580
    },
    { 
      date: 'Mar 25', 
      jinuPrice: 0.0040, 
      solPrice: 146.50, 
      userProfitLoss: 0.0020, 
      progressiveJackpot: 45000,
      activePlayers: 1250,
      activeBorrowers: 0.0025, 
      activeStakers: 750,
      activeLenders: 680
    },
    { 
      date: 'Mar 26', 
      jinuPrice: 0.0050, 
      solPrice: 142.75, 
      userProfitLoss: 0.0030, 
      progressiveJackpot: 47500,
      activePlayers: 1350,
      activeBorrowers: 0.0035, 
      activeStakers: 780,
      activeLenders: 750
    },
    { 
      date: 'Mar 27', 
      jinuPrice: 0.0065, 
      solPrice: 139.20, 
      userProfitLoss: 0.0050, 
      progressiveJackpot: 50000,
      activePlayers: 1450,
      activeBorrowers: 0.0045, 
      activeStakers: 810,
      activeLenders: 820
    },
    { 
      date: 'Mar 28', 
      jinuPrice: 0.0080, 
      solPrice: 135.50, 
      userProfitLoss: 0.0060, 
      progressiveJackpot: 52500,
      activePlayers: 1550,
      activeBorrowers: 0.0055, 
      activeStakers: 840,
      activeLenders: 900
    },
    { 
      date: 'Mar 29', 
      jinuPrice: 0.0095, 
      solPrice: 132.25, 
      userProfitLoss: 0.0070, 
      progressiveJackpot: 55000,
      activePlayers: 1650,
      activeBorrowers: 0.0065, 
      activeStakers: 870,
      activeLenders: 950
    },
    { 
      date: 'Mar 30', 
      jinuPrice: 0.0110, 
      solPrice: 130.00, 
      userProfitLoss: 0.0080, 
      progressiveJackpot: 57500,
      activePlayers: 1750,
      activeBorrowers: 0.0075, 
      activeStakers: 900,
      activeLenders: 1000
    },
    { 
      date: 'Mar 31', 
      jinuPrice: 0.0125, 
      solPrice: 127.50, 
      userProfitLoss: 0.0090, 
      progressiveJackpot: 60000,
      activePlayers: 1850,
      activeBorrowers: 0.0085, 
      activeStakers: 930,
      activeLenders: 1100
    },
    { 
      date: 'Apr 1', 
      jinuPrice: 0.0136, 
      solPrice: 125.00, 
      userProfitLoss: 0.0125, 
      progressiveJackpot: 62500,
      activePlayers: 1950,
      activeBorrowers: 0.0130, 
      activeStakers: 960,
      activeLenders: 1200
    },
  ]);
  
  // Fetch prices from CoinGecko (simulated)
  useEffect(() => {
    // In a real implementation, this would fetch from CoinGecko API
    const fetchPrices = async () => {
      try {
        // Simulated API response
        setJinuPrice(0.028);
        setSolPrice(75.32);
      } catch (error) {
        console.error("Error fetching prices:", error);
      }
    };
    
    fetchPrices();
    // Set up interval to refresh prices
    const interval = setInterval(fetchPrices, 60000);
    return () => clearInterval(interval);
  }, []);
  
  // Local chart data is now managed by the useDashboard hook
  
  // Handle game win
  const handleGameWin = (amount) => {
    // Update balance using the addToBalance function from BalanceContext
    addToBalance('jinu', amount);
    
    // Add to game engine activity
    addGameActivity({ 
      type: 'win', 
      user: 'Pirate Captain', // Using hardcoded username to avoid userStats reference
      amount, 
      time: Date.now() 
    });
    
    // Update game engine dashboard stats
    updateDashboard({
      progressiveJackpot: dashboard.progressiveJackpot - amount,
      activePlayers: dashboard.activePlayers + 1
    });
    
    toast({
      title: 'You Won!',
      description: `Congratulations! You won ${amount} JINU.`,
      status: 'success',
      duration: 3000,
      isClosable: true
    });
  };
  
  // Handle game loss
  const handleGameLoss = (amount) => {
    // Update balance using the subtractFromBalance function from BalanceContext
    subtractFromBalance('jinu', amount);
    
    // Add to game engine activity
    addGameActivity({ 
      type: 'loss', 
      user: 'Pirate Captain', // Using hardcoded username to avoid userStats reference
      amount, 
      time: Date.now() 
    });
    
    // Update game engine dashboard stats
    updateDashboard({
      progressiveJackpot: dashboard.progressiveJackpot + (amount * 0.75), // 75% goes to jackpot
      activePlayers: dashboard.activePlayers + 1
    });
    
    toast({
      title: 'Better Luck Next Time',
      description: `You lost ${amount} JINU. Try again!`,
      status: 'info',
      duration: 3000,
      isClosable: true
    });
  };

  // Handle logout
  const handleLogout = () => {
    toast({
      title: "Logged out",
      description: "You have been logged out successfully",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    // Navigate to the home page
    navigate('/');
  };

  // Handle game selection
  const handleGameSelect = (game) => {
    setActiveGame(game);
    
    // Use RESTful URL structure for navigation
    if (game === 'scratchCard') {
      navigate('/modular-profile/games/scratch-cards');
    } else {
      // For other game types, use the appropriate path
      navigate(`/modular-profile/games/${game}`);
    }
  };

  // Handle section navigation
  const handleSectionChange = (section) => {
    setActiveSection(section);
    setActiveGame(null); // Reset active game when changing sections
    
    // Use RESTful URL structure for navigation
    navigate(`/modular-profile/${section}`);
  };

  return (
    <Box 
      position="relative" 
      minH="100vh"
      overflow="auto"
      bg="gray.900"
    >
      {/* Game-style Navigation Bar */}
      <NavbarFix onToggleChat={() => setIsChatOpen(!isChatOpen)} />
      
      {/* Left Sidebar */}
      <ProfileSidebar 
        activeSection={activeSection} 
        setActiveSection={setActiveSection} 
        userStats={{...userStats, balance}}
        goldColor={goldColor}
        onLogout={handleLogout}
      />
      
      {/* Main Content */}
      <Box 
        position="absolute" 
        top="84px" 
        left="266px" 
        w={isChatOpen ? "calc(100vw - 590px)" : "calc(100vw - 290px)"} 
        h="calc(100vh - 92px)" 
        overflowY="auto"
        p={4}
        transition="width 0.3s ease"
      >
        {/* Dashboard */}
        {activeSection === "dashboard" && (
          <DashboardAdapter
            userStats={{...userStats, balance}}
            setUserStats={setUserStats}
            chartTimeframe={engineChartTimeframe}
            setChartTimeframe={setEngineChartTimeframe}
            getTimeframeData={getTimeframeData}
            recentActivity={recentActivity}
            goldColor={goldColor}
          >
            <VStack spacing={4} align="stretch">
              <Heading color="white" size="md" display="flex" alignItems="center">
                <Icon as={FaChartLine} mr={2} color="cyan.400" />
                Dashboard
              </Heading>
              
              {/* Financial Stats Cards */}
              <UserStatsBoxes userStats={{...userStats, balance}} />
              
              {/* Dashboard Value Boxes now rendered in MarketPerformanceSection */}
              
              {/* Market Performance Section with Chart */}
              <MarketPerformanceSection 
                chartTimeframe={engineChartTimeframe}
                setChartTimeframe={setEngineChartTimeframe}
                getTimeframeData={getTimeframeData}
                goldColor={goldColor}
                userStats={userStats}
              />
              
              {/* Community Activity Hub */}
              <CommunityActivityHub 
                recentActivity={recentActivity}
                goldColor={goldColor}
              />
            </VStack>
          </DashboardAdapter>
        )}

        {activeSection === "games" && (
          <Suspense fallback={<Center p={10}><Spinner size="xl" color="blue.500" /></Center>}>
            <ModularGamesContent />
          </Suspense>
        )}

        {activeSection === "dex" && (
          <DEXSwapComponent />
        )}

        {activeSection === "dao" && (
          <DAODashboard />
        )}

        {activeSection === "staking" && (
          <Box p={4} bg="rgba(23, 25, 35, 0.9)" borderRadius="lg" borderWidth="1px" borderColor="green.500">
            <Heading color="white" size="md" mb={4} display="flex" alignItems="center">
              <Icon as={FaCoins} mr={2} color="green.400" />
              LP Staking
            </Heading>
            <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4}>
              <Box p={4} bg="rgba(13, 16, 25, 0.7)" borderRadius="lg" borderWidth="1px" borderColor="green.500">
                <Heading size="sm" mb={4} color="white">Your Stakes</Heading>
                <VStack spacing={3} align="stretch">
                  <Flex justify="space-between">
                    <Text color="gray.400">Total Staked</Text>
                    <Text color="white">2,500,000 JINU</Text>
                  </Flex>
                  <Flex justify="space-between">
                    <Text color="gray.400">Rewards Earned</Text>
                    <Text color="green.400">125,000 JINU</Text>
                  </Flex>
                  <Flex justify="space-between">
                    <Text color="gray.400">APR</Text>
                    <Text color="green.400">42%</Text>
                  </Flex>
                  <Flex justify="space-between">
                    <Text color="gray.400">Lock Period</Text>
                    <Text color="white">30 days</Text>
                  </Flex>
                </VStack>
                <HStack spacing={4} mt={4}>
                  <Button colorScheme="green" flex={1}>Stake More</Button>
                  <Button colorScheme="red" variant="outline" flex={1}>Unstake</Button>
                </HStack>
              </Box>
              <Box p={4} bg="rgba(13, 16, 25, 0.7)" borderRadius="lg" borderWidth="1px" borderColor="green.500">
                <Heading size="sm" mb={4} color="white">Staking Pools</Heading>
                <VStack spacing={3} align="stretch">
                  {[
                    { name: "JINU-SOL LP", apr: "42%", tvl: "$12.5M" },
                    { name: "JINU-USDC LP", apr: "36%", tvl: "$8.2M" },
                    { name: "JINU Single", apr: "24%", tvl: "$5.7M" }
                  ].map((pool, index) => (
                    <Flex 
                      key={index} 
                      justify="space-between"
                      p={2}
                      borderRadius="md"
                      borderWidth="1px"
                      borderColor="green.600"
                      _hover={{
                        bg: "rgba(72, 187, 120, 0.1)",
                      }}
                    >
                      <Text color="white">{pool.name}</Text>
                      <HStack spacing={4}>
                        <Text color="green.400">{pool.apr}</Text>
                        <Text color="blue.400">{pool.tvl}</Text>
                        <Button size="xs" colorScheme="green">Stake</Button>
                      </HStack>
                    </Flex>
                  ))}
                </VStack>
              </Box>
            </SimpleGrid>
          </Box>
        )}

        {activeSection === "pawnshop" && (
          <Suspense fallback={<Center p={10}><Spinner size="xl" color="purple.500" /></Center>}>
            <PawnShopComponent />
          </Suspense>
        )}

        {activeSection === "nftlootboxes" && (
          <Suspense fallback={<Center p={10}><Spinner size="xl" color="purple.500" /></Center>}>
            <NFTLootboxesComponent />
          </Suspense>
        )}
        
        {activeSection === "raffles" && (
          <Suspense fallback={<Center p={10}><Spinner size="xl" color="blue.500" /></Center>}>
            <Box>
              
              <RaffleTabWrapper
                createRaffleContent={
                  <Box>
                    <NewRaffleTab 
                      raffleAssetType={raffleAssetType}
                      setRaffleAssetType={setRaffleAssetType}
                      selectedRaffleNft={selectedRaffleNft}
                      setSelectedRaffleNft={setSelectedRaffleNft}
                      nftData={userNFTs.reduce((acc, nft) => {
                        acc[nft.id] = nft;
                        return acc;
                      }, {})}
                      selectedTokenSymbol={selectedTokenSymbol}
                      setSelectedTokenSymbol={setSelectedTokenSymbol}
                      selectedTokenAmount={selectedTokenAmount}
                      setSelectedTokenAmount={setSelectedTokenAmount}
                      selectedTokenAddress={selectedTokenAddress}
                      setSelectedTokenAddress={setSelectedTokenAddress}
                      raffleTicketPrice={raffleTicketPrice}
                      setRaffleTicketPrice={setRaffleTicketPrice}
                      raffleTotalTickets={raffleTotalTickets}
                      setRaffleTotalTickets={setRaffleTotalTickets}
                      raffleDuration={raffleDuration}
                      setRaffleDuration={setRaffleDuration}
                      handleCreateRaffle={handleCreateRaffle}
                      topTokens={topTokens}
                      searchTokens={searchTokens}
                      setSearchTokens={setSearchTokens}
                      tokenSearchQuery={tokenSearchQuery}
                      setTokenSearchQuery={setTokenSearchQuery}
                      handleTokenSearch={handleTokenSearch}
                    />
                  </Box>
                }
                myRafflesContent={
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} mt={4}>
                    {userRaffles.map(raffle => (
                      <Box
                        key={raffle.id}
                        bg={cardBg}
                        borderRadius="lg"
                        borderWidth="1px"
                        borderColor={raffle.status === 'active' ? 'blue.400' : 'gray.700'}
                      >
                        <Flex direction="column" h="100%">
                          <Flex mb={4} p={3}>
                            <Box 
                              w="100px" 
                              h="100px" 
                              bg="blue.900" 
                              borderRadius="lg" 
                              mr={4}
                              overflow="hidden"
                              flexShrink={0}
                              p={2}
                              boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                              border="1px solid"
                              borderColor="blue.400"
                            >
                              <Image 
                                src={raffle.asset.image} 
                                alt={raffle.asset.name} 
                                w="100%"
                                h="100%"
                                objectFit="cover"
                                borderRadius="md"
                              />
                            </Box>
                            <Box>
                              <Text color="white" fontWeight="bold">{raffle.asset.name}</Text>
                              <HStack spacing={2} mt={1}>
                                <Badge colorScheme={raffle.status === 'active' ? 'green' : 'gray'}>
                                  {raffle.status === 'active' ? 'Active' : 'Completed'}
                                </Badge>
                                <Text color="gray.400" fontSize="sm">
                                  {raffle.soldTickets}/{raffle.totalTickets} tickets sold
                                </Text>
                              </HStack>
                            </Box>
                          </Flex>
                          
                          <VStack spacing={3} align="stretch" flex="1" p={4}>
                            <Flex justify="space-between">
                              <Text color="gray.400">Ticket Price:</Text>
                              <Text color="white">{raffle.ticketPrice} JINU</Text>
                            </Flex>
                            
                            <Box mt={2}>
                              <Progress 
                                value={(raffle.soldTickets / raffle.totalTickets) * 100} 
                                colorScheme="blue"
                                borderRadius="full"
                                size="sm"
                              />
                            </Box>
                            
                            <Flex justify="space-between">
                              <Text color="gray.400">End Date:</Text>
                              <Text color="white">{raffle.endDate}</Text>
                            </Flex>
                            
                            <Flex justify="space-between">
                              <Text color="gray.400">Earnings:</Text>
                              <Text color="blue.300" fontWeight="bold">
                                {raffle.ticketPrice * raffle.soldTickets * 0.95} JINU
                              </Text>
                            </Flex>
                            
                            {raffle.status === 'completed' && (
                              <Flex justify="space-between">
                                <Text color="gray.400">Winner:</Text>
                                <Text color="white">{raffle.winner}</Text>
                              </Flex>
                            )}
                          </VStack>
                          
                          <Button 
                            leftIcon={<FaShareAlt />}
                            colorScheme="blue" 
                            variant="outline"
                            mt={4}
                            onClick={() => handleShareRaffle(raffle.id)}
                          >
                            Share Raffle
                          </Button>
                        </Flex>
                      </Box>
                    ))}
                  </SimpleGrid>
                }
                activeRafflesContent={
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} mt={4}>
                    {activeRaffles.map(raffle => (
                      <Box
                        key={raffle.id}
                        bg={cardBg}
                        borderRadius="lg"
                        borderWidth="1px"
                        borderColor="blue.400"
                      >
                        <Flex direction="column" h="100%">
                          <Flex mb={4} p={3}>
                            <Box 
                              w="100px" 
                              h="100px" 
                              bg={raffle.isToken ? 'blue.900' : 'blue.800'} 
                              borderRadius="lg" 
                              mr={4}
                              overflow="hidden"
                              flexShrink={0}
                              p={1}
                              boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                              border="1px solid"
                              borderColor="blue.400"
                            >
                              <Image 
                                src={raffle.asset.image} 
                                alt={raffle.asset.name} 
                                w="100%"
                                h="100%"
                                objectFit="cover"
                                borderRadius="md"
                              />
                            </Box>
                            <Box>
                              <Text color="white" fontWeight="bold">{raffle.asset?.name}</Text>
                              <HStack spacing={2} mt={1}>
                                <Badge colorScheme="blue">
                                  {raffle.isToken ? 'Token' : 'NFT'}
                                </Badge>
                                {raffle.soldTickets / raffle.totalTickets > 0.8 && (
                                  <Badge colorScheme="red">
                                    Hot
                                  </Badge>
                                )}
                              </HStack>
                            </Box>
                          </Flex>
                          
                          <VStack spacing={3} align="stretch" flex="1" p={4}>
                            <Flex justify="space-between">
                              <Text color="gray.400">Creator:</Text>
                              <Text color="white">{raffle.creator}</Text>
                            </Flex>
                            
                            <Flex justify="space-between">
                              <Text color="gray.400">Ticket Price:</Text>
                              <Text color="white">{raffle.ticketPrice} JINU</Text>
                            </Flex>
                            
                            <Box mt={2}>
                              <Progress 
                                value={(raffle.soldTickets / raffle.totalTickets) * 100} 
                                colorScheme="blue"
                                borderRadius="full"
                                size="sm"
                              />
                            </Box>
                            
                            <Flex justify="space-between">
                              <Text color="gray.400">Tickets:</Text>
                              <Text color="white">{raffle.soldTickets}/{raffle.totalTickets}</Text>
                            </Flex>
                            
                            <Flex justify="space-between">
                              <Text color="gray.400">Time Left:</Text>
                              <Text color="white">{formatTimeRemaining(raffle.endDate)}</Text>
                            </Flex>
                          </VStack>
                          
                          <Button 
                            colorScheme="blue" 
                            mt={4}
                            onClick={() => handleBuyTickets(raffle.id)}
                          >
                            Buy Ticket
                          </Button>
                        </Flex>
                      </Box>
                    ))}
                  </SimpleGrid>
                }
              />
            </Box>
          </Suspense>
        )}
        
        {activeSection === "marketplace" && (
          <Suspense fallback={<Center p={10}><Spinner size="xl" color="purple.500" /></Center>}>
            <NFTMarketplace />
          </Suspense>
        )}

        {activeSection === "affiliate" && (
          <Box p={4} bg="rgba(23, 25, 35, 0.9)" borderRadius="lg" borderWidth="1px" borderColor="red.800">
            <AffiliateDashboard />
          </Box>
        )}
        
        {/* Settings Tab */}
        {activeSection === "settings" && (
          <Box p={6} bg="rgba(23, 25, 35, 0.9)" borderRadius="lg" borderWidth="1px" borderColor="gray.700">
            <Heading color="white" size="md" mb={6} display="flex" alignItems="center">
              <Icon as={FaCog} mr={2} color="gray.400" />
              Profile Settings
            </Heading>
            
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
              {/* Profile Picture Section */}
              <Box>
                <Heading size="sm" color="white" mb={4}>Profile Picture</Heading>
                <Flex direction="column" align="center">
                  <Box position="relative" mb={4}>
                    <Avatar 
                      size="2xl" 
                      name={profileData.username} 
                      src={profileData.avatar} 
                      border="3px solid"
                      borderColor={goldColor}
                    />
                    <IconButton
                      aria-label="Change profile picture"
                      icon={<FaCamera />}
                      size="sm"
                      colorScheme="yellow"
                      borderRadius="full"
                      position="absolute"
                      bottom="0"
                      right="0"
                      onClick={onAvatarModalOpen}
                    />
                    <Input 
                      type="file" 
                      hidden 
                      ref={fileInputRef} 
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onload = (e) => {
                            // Set the temporary avatar for preview
                            setTempAvatar(e.target.result);
                            setAvatarPreview(e.target.result);
                            setIsEditingAvatar(true);
                            // Open the modal to show the preview
                            onAvatarModalOpen();
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                  </Box>
                  <HStack spacing={2}>
                    <Button 
                      leftIcon={<FaUpload />} 
                      colorScheme="yellow" 
                      variant="outline"
                      size="sm"
                      onClick={() => fileInputRef.current.click()}
                    >
                      Upload New Picture
                    </Button>
                    <Button
                      leftIcon={<FaEdit />}
                      colorScheme="cyan"
                      variant="outline"
                      size="sm"
                      onClick={onAvatarModalOpen}
                    >
                      Edit Picture
                    </Button>
                  </HStack>
                </Flex>
              </Box>
              
              {/* Profile Information Section */}
              <Box>
                <Heading size="sm" color="white" mb={4}>Profile Information</Heading>
                <VStack spacing={4} align="stretch">
                  <FormControl>
                    <FormLabel color="gray.300">Username</FormLabel>
                    <Input 
                      value={profileData.username} 
                      onChange={(e) => setProfileData(prev => ({ ...prev, username: e.target.value }))}
                      bg="rgba(13, 16, 25, 0.7)"
                      borderColor="gray.600"
                      color="white"
                    />
                  </FormControl>
                  
                  <FormControl>
                    <FormLabel color="gray.300">Bio</FormLabel>
                    <Textarea 
                      value={profileData.bio} 
                      onChange={(e) => setProfileData(prev => ({ ...prev, bio: e.target.value }))}
                      bg="rgba(13, 16, 25, 0.7)"
                      borderColor="gray.600"
                      color="white"
                      resize="vertical"
                      rows={3}
                    />
                  </FormControl>
                  
                  <Button 
                    leftIcon={<FaSave />} 
                    colorScheme="green" 
                    mt={2}
                    onClick={() => {
                      toast({
                        title: "Profile updated",
                        description: "Your profile has been successfully updated.",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                      });
                    }}
                  >
                    Save Changes
                  </Button>
                </VStack>
              </Box>
            </SimpleGrid>
            
            <Divider my={8} borderColor="gray.700" />
            
            {/* Social Media Section */}
            <Box>
              <Heading size="sm" color="white" mb={4}>Social Media</Heading>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormControl>
                  <FormLabel color="gray.300">Twitter Handle</FormLabel>
                  <Input 
                    value={profileData.twitter} 
                    onChange={(e) => setProfileData(prev => ({ ...prev, twitter: e.target.value }))}
                    bg="rgba(13, 16, 25, 0.7)"
                    borderColor="gray.600"
                    color="white"
                    placeholder="@username"
                  />
                </FormControl>
                
                <FormControl>
                  <FormLabel color="gray.300">Discord Username</FormLabel>
                  <Input 
                    value={profileData.discord} 
                    onChange={(e) => setProfileData(prev => ({ ...prev, discord: e.target.value }))}
                    bg="rgba(13, 16, 25, 0.7)"
                    borderColor="gray.600"
                    color="white"
                    placeholder="username#0000"
                  />
                </FormControl>
              </SimpleGrid>
              
              <Button 
                leftIcon={<FaSave />} 
                colorScheme="blue" 
                mt={4}
                onClick={() => {
                  toast({
                    title: "Social profiles updated",
                    description: "Your social media profiles have been updated.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                  });
                }}
              >
                Save Social Profiles
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      
      {/* Avatar Editor Modal */}
      <Modal isOpen={isAvatarModalOpen} onClose={onAvatarModalClose} size="xl" isCentered>
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent bg="gray.800" color="white" borderRadius="lg" boxShadow="dark-lg">
          <ModalHeader display="flex" alignItems="center">
            <Icon as={FaCamera} mr={2} color="yellow.400" />
            Edit Profile Picture
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={6}>
              {/* Current Avatar */}
              <Box>
                <Text fontWeight="medium" mb={2}>Current Picture</Text>
                <Avatar 
                  size="xl" 
                  name={profileData.username} 
                  src={profileData.avatar} 
                  border="3px solid"
                  borderColor={goldColor}
                />
              </Box>
              
              {/* Avatar Preview */}
              <Box width="100%">
                <Text fontWeight="medium" mb={2}>New Picture Preview</Text>
                <Flex justify="center" mb={4}>
                  <Avatar 
                    size="xl" 
                    name={profileData.username} 
                    src={avatarPreview || tempAvatar || profileData.avatar} 
                    border="3px solid"
                    borderColor="cyan.400"
                  />
                </Flex>
                
                {/* Upload Controls */}
                <VStack spacing={4} align="stretch">
                  <Button 
                    leftIcon={<FaUpload />} 
                    colorScheme="yellow" 
                    onClick={() => {
                      // Close modal first to prevent strange behavior
                      onAvatarModalClose();
                      // Slight delay before opening file picker
                      setTimeout(() => {
                        fileInputRef.current.click();
                      }, 100);
                    }}
                    width="100%"
                  >
                    Upload New Image
                  </Button>
                  
                  {/* Preset Avatars */}
                  <Box>
                    <Text fontWeight="medium" mb={2}>Choose from Presets</Text>
                    <SimpleGrid columns={4} spacing={3}>
                      {[1, 2, 3, 4, 5, 6, 7, 8].map((id) => (
                        <Avatar 
                          key={id}
                          size="md" 
                          src={`https://avatars.dicebear.com/api/human/${id * 123}.svg`}
                          cursor="pointer"
                          onClick={() => {
                            setAvatarPreview(`https://avatars.dicebear.com/api/human/${id * 123}.svg`);
                            setTempAvatar(`https://avatars.dicebear.com/api/human/${id * 123}.svg`);
                          }}
                          border={avatarPreview === `https://avatars.dicebear.com/api/human/${id * 123}.svg` ? "2px solid" : "none"}
                          borderColor="cyan.400"
                        />
                      ))}
                    </SimpleGrid>
                  </Box>
                  
                  {/* Avatar Styling Options */}
                  <Box>
                    <Text fontWeight="medium" mb={2}>Avatar Border</Text>
                    <SimpleGrid columns={4} spacing={3}>
                      {["yellow.400", "cyan.400", "purple.400", "green.400", "red.400", "blue.400", "orange.400", "pink.400"].map((color) => (
                        <Box 
                          key={color}
                          w="40px" 
                          h="40px" 
                          borderRadius="full" 
                          bg={color}
                          cursor="pointer"
                          onClick={() => {
                            // In a real app, this would change the avatar border color
                            toast({
                              title: "Border color selected",
                              description: "This would change your avatar border color in a full implementation.",
                              status: "info",
                              duration: 2000,
                            });
                          }}
                        />
                      ))}
                    </SimpleGrid>
                  </Box>
                </VStack>
              </Box>
            </VStack>
          </ModalBody>
          
          <ModalFooter>
            <Button 
              colorScheme="green" 
              mr={3} 
              leftIcon={<FaSave />}
              onClick={() => {
                if (avatarPreview) {
                  setProfileData(prev => ({
                    ...prev,
                    avatar: avatarPreview
                  }));
                  
                  toast({
                    title: "Profile picture updated",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                  });
                }
                onAvatarModalClose();
              }}
            >
              Save New Picture
            </Button>
            <Button variant="ghost" onClick={onAvatarModalClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
      {/* Right Sidebar - Discord Chat - Now toggled from navbar */}
      {isChatOpen && (
        <Box
          position="fixed"
          top="84px"
          right="0"
          height="calc(100vh - 84px)"
          width="300px"
          zIndex="10"
          transition="all 0.3s ease"
        >
          <CommunityChatSidebar 
            goldColor={goldColor}
            goldBorder={goldBorder}
            goldAccent={goldAccent}
          />
        </Box>
      )}
    </Box>
  );
};

export default ModularUserProfile;
